{
  "en": {
    "nav": {
      "cart": "Cart",
      "locations": "Locations",
      "home": "Home",
      "back": "Back",
      "navigation": "Navigation",
      "ships": {
        "index": "Ships"
      },
      "compare": {
        "index": "Compare",
        "ships": "Ships",
        "components": "Components",
        "equipment": "Equipment"
      },
      "manufacturers": "Manufacturers",
      "images": "Images",
      "videos": "Videos",
      "shipHistory": "History",
      "componentHistory": "History",
      "hangar": {
        "index": "My Hangar",
        "overview": "Overview",
        "wishlist": "Wishlist",
        "stats": "Stats",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "blueprints": "Blueprints",
        "assets": "Assets",
        "vehicleCargo": "Cargo",
        "buybacks": "Buy-Backs",
        "paints": "Paints",
        "flair": "Hangar Flair",
        "upgrades": "Upgrades / CCUs",
        "equipment": "FPS Gear",
        "pledgeItems": "Pledge Items",
        "imports": "Imports",
        "transfers": "Transfers",
        "vehicleOverview": "Overview",
        "vehicleLog": "Captain's Log",
        "shipComponents": "Ship Components",
        "plans": "Planner",
        "sharedPlan": "Shared Plan"
      },
      "login": "Login",
      "installApp": "Install app",
      "logout": "Logout",
      "apiV1": "API v1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Pagination",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "embed": "Embed Widget",
      "signUp": "Sign up",
      "privacyPolicy": "Privacy policy",
      "impressum": "Impressum",
      "fleets": {
        "index": "Fleets",
        "add": "Create a new Fleet",
        "invites": "Invites",
        "ships": "Ships",
        "blueprints": "Blueprints",
        "assets": "Assets",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "Worldmap",
          "starmap": "Starmap",
          "health": "Health"
        },
        "squadrons": {
          "index": "Squadrons",
          "overview": "Overview",
          "members": "Members",
          "create": {
            "details": "Details",
            "appearance": "Appearance",
            "discord": "Discord"
          },
          "edit": {
            "details": "Details",
            "appearance": "Appearance",
            "discord": "Discord"
          }
        },
        "stats": "Stats",
        "logistics": {
          "index": "Logistics"
        },
        "shoppingLists": "Shopping Lists",
        "missions": {
          "index": "Missions",
          "edit": {
            "details": "Details",
            "teams": "Teams & slots"
          }
        },
        "events": {
          "index": "Events",
          "calendar": "Calendar",
          "edit": {
            "details": "Details",
            "schedule": "Schedule",
            "signup": "Sign-up",
            "teams": "Teams & slots"
          },
          "payouts": "Payouts"
        },
        "tours": "Tours",
        "settings": {
          "index": "Settings",
          "fleet": "Fleet Settings",
          "rsi": "Fleet ID & RSI",
          "membership": "Membership Settings",
          "roles": "Roles",
          "squadrons": "Squadrons",
          "allies": "Allies",
          "notifications": "Notifications",
          "discord": "Discord",
          "calendar": "Calendar",
          "features": "Features",
          "contracts": "Contracts"
        },
        "contracts": {
          "index": "Contracts",
          "payouts": "Payouts"
        },
        "directory": "Directory",
        "overview": "Overview"
      },
      "rsiProfile": "RSI Profile",
      "rsiHangar": "RSI Hangar",
      "tools": {
        "index": "Tools",
        "overview": "Overview",
        "travelTimes": "Travel Times",
        "cargoGrids": "Cargo Grids",
        "plaque": "Dedication Plaques",
        "tradeRoutes": "Trade Routes",
        "dressingRoom": "Dressing Room",
        "paintBooth": "Paint Booth",
        "tours": "Tours"
      },
      "api": "API Docs",
      "stats": "Stats",
      "toggleSlimCollapse": "Collapse",
      "toggleSlimExpand": "Expand",
      "roadmap": {
        "index": "Roadmap",
        "overview": "Overview",
        "changes": "Changes",
        "ships": "Ship-Roadmap"
      },
      "rsiVerification": "RSI Verification",
      "settings": {
        "index": "Settings",
        "profile": "Profile",
        "account": "Account",
        "security": "Security",
        "notifications": "Notifications",
        "calendar": "Calendar",
        "donations": "Donations",
        "hangar": "Hangar",
        "privacy": "Privacy",
        "features": "Features",
        "connections": "Connections",
        "oauthApplications": "OAuth Apps",
        "verify": "RSI Account Verification",
        "friends": "Friends"
      },
      "reload": "Update available!",
      "visualTests": {
        "blueprints": "Blueprints",
        "index": "Visual Tests",
        "panels": "Panels",
        "buttons": "Buttons",
        "events": "Events",
        "typography": "Typography",
        "forms": "Forms",
        "tables": "Tables",
        "lists": "Lists",
        "metrics": "Metrics",
        "states": "States",
        "notifications": "Notifications",
        "dedicationPlaques": "Dedication Plaques",
        "syncModal": "Sync Modal",
        "buybackSyncModal": "Buy-back Sync Modal",
        "rsiVerificationModal": "RSI Verification Modal",
        "fleetRsiVerificationModal": "Fleet RSI Verification Modal",
        "overlays": "Overlays",
        "installPrompt": "Install Prompt",
        "supportHint": "Support Hint",
        "media": "Media",
        "charts": "Charts",
        "alerts": "Alerts",
        "verifiedBadges": "Verified Badges",
        "chips": "Chips",
        "squadrons": "Squadrons",
        "groups": {
          "foundations": "Foundations",
          "data": "Data",
          "feedback": "Feedback",
          "features": "Features"
        },
        "notificationCenter": "Notification Center",
        "themes": "Themes"
      },
      "admin": {
        "features": {
          "overview": "Overview",
          "users": "Users",
          "fleets": "Fleets",
          "history": "History"
        },
        "locations": {
          "index": "Locations"
        },
        "blueprints": {
          "index": "Blueprints"
        },
        "missions": {
          "index": "Missions"
        },
        "index": "Admin",
        "models": {
          "index": "Models",
          "create": "Create Model",
          "edit": {
            "index": "Base Data",
            "metrics": "Metrics",
            "prices": "Prices",
            "docks": "Docks",
            "modules": "Modules",
            "paints": "Paints",
            "images": "Images",
            "videos": "Videos",
            "cargoAndFuel": "Fuel",
            "cargoHolds": "Cargo Holds",
            "fleetchart": "Fleetchart Images",
            "positions": "Positions",
            "hardpoints": "Hardpoints",
            "loaners": "Loaners",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Upgrades",
            "packages": "Packages",
            "history": "History"
          }
        },
        "modelPaints": {
          "index": "Paints",
          "create": "Create Paint"
        },
        "modelModules": {
          "index": "Modules",
          "create": "Create Module",
          "edit": {
            "index": "Base Data",
            "models": "Models",
            "prices": "Prices",
            "hardpoints": "Hardpoints",
            "docks": "Docks",
            "cargoHolds": "Cargo Holds",
            "history": "History"
          }
        },
        "unlistedModels": {
          "index": "Unlisted Ships"
        },
        "modelModulePackages": {
          "index": "Module Packages",
          "create": "Create Module Package"
        },
        "components": {
          "index": "Components",
          "edit": {
            "index": "Base Data",
            "prices": "Prices",
            "history": "History"
          }
        },
        "manufacturers": {
          "index": "Manufacturers",
          "edit": {
            "index": "Base Data",
            "models": "Ships",
            "components": "Components",
            "equipment": "Equipment",
            "modules": "Modules"
          }
        },
        "images": {
          "index": "Images"
        },
        "users": {
          "index": "Users",
          "edit": "Edit",
          "fleets": "Fleets",
          "inventories": "Inventories",
          "supporterContributions": "Contributions"
        },
        "fleets": {
          "index": "Fleets",
          "edit": "Edit",
          "members": "Members",
          "history": "History",
          "roles": "Roles",
          "inventories": "Inventories"
        },
        "fleetFidClaims": {
          "index": "FID Claims"
        },
        "destroyedFleets": {
          "index": "Destroyed Fleets"
        },
        "vehicles": {
          "index": "Vehicles"
        },
        "admins": {
          "index": "Admins"
        },
        "oauthApplications": {
          "index": "OAuth Apps"
        },
        "maintenance": {
          "index": "Maintenance",
          "pghero": "PG-Hero",
          "features": "Features",
          "workers": "Workers",
          "tasks": "Tasks",
          "imports": "Imports",
          "rsiApiStatus": "RSI API Status",
          "buildCompare": "Build Compare"
        },
        "announcements": {
          "index": "Announcements",
          "new": "New Announcement",
          "edit": "Edit Announcement"
        },
        "supporterContributions": {
          "index": "Supporter Contributions",
          "new": "New Supporter Contribution",
          "edit": "Edit Supporter Contribution"
        },
        "fundingGoals": {
          "index": "Funding Goals",
          "new": "New Funding Goal",
          "edit": "Edit Funding Goal"
        },
        "homepage": "Homepage",
        "gameEvents": {
          "index": "Game Events",
          "new": "New Game Event",
          "edit": "Edit Game Event"
        },
        "notifications": {
          "index": "Notifications"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Visual Tests",
          "notifications": "Notifications"
        },
        "groups": {
          "catalogue": "Catalogue",
          "community": "Community",
          "people": "People",
          "system": "System"
        }
      },
      "notifications": "Notifications",
      "scDataSource": "Data source",
      "commodities": {
        "index": "Commodities"
      },
      "components": {
        "index": "Components"
      },
      "catalogue": {
        "commodities": "Commodities",
        "index": "Catalogue",
        "components": "Components",
        "blueprints": "Blueprints",
        "missions": "Missions",
        "equipment": "Equipment"
      },
      "equipment": {
        "index": "Equipment"
      },
      "switcher": {
        "label": "Switch between your hangar and your fleets",
        "personal": "Personal",
        "yourFleets": "Your fleets",
        "fleetDirectory": "Fleet directory",
        "switch": "Switch"
      },
      "account": {
        "menu": "Account menu",
        "unread": "%{count} unread"
      }
    }
  }
}
